"use client";

import { PropsWithChildren } from "react";
import { useNotifications } from "@/hooks";
import { useInternalFeatureFlags } from "@/hooks/feature-flags";

export function NotificationProvider({ children }: PropsWithChildren) {
  // Initialize the notifications SSE connection
  useNotifications();

  // Fetch internal feature flags (cached with staleTime: Infinity, updated via SSE)
  useInternalFeatureFlags();

  return <>{children}</>;
}
